
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';

const CustomerEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId]);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({});
    const [CustomerRateRelation, setCustomerRateRelation] = useState([]);

    useEffect(() => {
        fetchData('CustomerApi', `/CustomerData/${id}`, token)//, token
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId]);

    const submitData = async () => {
        // Update CreatedBy field
        setFormData((prevData) => ({
            ...prevData,
            CreatedBy: userId,
        }));

        // Fetch existing items for validation
        const existingItems = await fetchData('WorkApi', `/${companyId}`, token); //, token
        console.log('Existing Items:', existingItems);

        const existingItem = existingItems.response_data?.find(
            (item) => item.Name === formData.Name
        );

        // If no changes are made, skip the update
        if (
            existingItems.response_data &&
            Array.isArray(existingItems.response_data) &&
            existingItems.response_data.some(
                (item) => item.Name === formData.Name && item.GSTNo === formData.GSTNo && item.Contact1 == formData.Contact1
            )
        ) {
            alert('Item with the same Name already exists.');
            return;
        }

        // Validate form data
        if (!formData.Name) {
            alert('Name is required.');
            return;
        }

        if (!formData.Contact1) {
            alert('Contact 1 is required.');
            return;
        }

        if (!formData.Address1) {
            alert('Address 1 is required.');
            return;
        }

        // Update data
        try {
            const response = await updateData('CustomerApi', id, formData, token);
            console.log('Record updated successfully:', response);
            setSuccessMessage('Record updated successfully.');
            setTimeout(() => setSuccessMessage(''), 3000);
            history.push('/CustomerIndex');
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const [editIndex, setEditIndex] = useState(null);
    const [editedData, setEditedData] = useState({});

    const handleEditClick = (index) => {
        setEditIndex(index);
        setEditedData(CustomerRateRelation[index]);
    };

    const handleInputChange = (field, value) => {
        setEditedData({
            ...editedData,
            [field]: value,
        });
    };

    const handleSaveClick = (index) => {
        handleEditChange(index, editedData);
        setEditIndex(null);
    };

    const handleEditChange = (index, updatedData) => {

        const updatedSlabs = CustomerRateRelation.map((slab, idx) =>
            idx === index ? updatedData : slab
        );
        setCustomerRateRelation(updatedSlabs);
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '-25px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Customer Edit</h6>

                    <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0, marginTop: '-10px' }}>
                        {/* Save Button */}
                        <Button
                            variant="contained"
                            onClick={submitData}
                            disabled={isLoading}
                            style={{
                                height: "25px",
                                minWidth: "80px",
                                borderRadius: "6px",
                                backgroundColor: "#1E3A8A",
                                color: "#FFFFFF",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                        >
                            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Update"}
                        </Button>

                        {/* Back To List Button */}
                        <Button
                            variant="contained"
                            component={Link}
                            to="/CustomerIndex"
                            className="linkcolor"
                            onClick={() => localStorage.setItem("shouldReload", "true")}
                            style={{
                                height: "25px",
                                minWidth: "90px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F4F6",
                                color: "#1E3A8A",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                        >
                            Back To List
                        </Button>
                    </div>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full flex flex-wrap">
                        <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                            <div className="w-full mb-3 flex" >

                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Name<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Name"
                                        name='Name'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Contact 1<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Contact1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact No 1"
                                        name='Contact1'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Contact 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Contact2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact No 2"
                                        name='Contact2'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                            </div>
                            <div className="w-full mb-3 flex" >
                                <div className="w-2/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Email"
                                        name='Email'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        GST No
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.GSTNo}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST No"
                                        name='GSTNo'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-2/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Site
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Location}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Site"
                                        name='Location'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Pincode
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Pincode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Pin Code"
                                        name='Pincode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                            </div>
                            <div className="w-full mb-3 flex" >
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Address 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Address1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Address Line 1"
                                        name='Address1'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Address 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Address2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Address Line 2"
                                        name='Address2'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div >
        </Fragment >
    );
};

export default CustomerEdit;